import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
function cambiarTextoBotonTransferencia() {
  document.querySelectorAll('button, a').forEach(el => {
    const texto = el.textContent.trim().toLowerCase();

    if (texto.includes('transferencia')) {
      el.textContent = 'PAGAR CON TRANSFERENCIA 20% OFF';
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  cambiarTextoBotonTransferencia();

  const observer = new MutationObserver(() => {
    cambiarTextoBotonTransferencia();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});